<div class="search-suggest-brands">
  <div class="d-flex justify-content-start headline">{{ 'suggest.brands.headline' | translate }}</div>
  <ul>
    <li *ngFor="let brand of brands | slice : 0 : maxAutoSuggests">
      <!--DIAS CUSTOMIZATION STARTS-->
      <ng-container *ngIf="(isFeatureEnabled$() | async) === false">
        <a
          [routerLink]="['search', inputTerms$ | async]"
          [queryParams]="{ filters: 'ManufacturerName=' + brand.brandName }"
          [innerHTML]="brand.brandName | ishHighlight : (inputTerms$ | async)"
          (click)="handleInputFocus()"
        ></a>
      </ng-container>

      <ng-container *ngIf="(isFeatureEnabled$() | async) === true">
        <a
          [routerLink]="['search', inputTerms$ | async]"
          [queryParams]="{ filters: 'brand=' + brand.brandName }"
          [innerHTML]="brand.brandName | ishHighlight : (inputTerms$ | async)"
          (click)="handleInputFocus()"
        ></a>
      </ng-container>
      <!--DIAS CUSTOMIZATION ENDS-->
    </li>
  </ul>
</div>
